const createStatementHandler = (args) => {
    return {
        type: args.type,
        create: data => ({ type: args.type, ...data }),
        serialize: stmt => (args.serialize ? args.serialize(stmt) : null),
        getHumanStmt: stmt => (args.getHumanStmt ? args.getHumanStmt(stmt) : null),
        parse: line => {
            const data = args.parse(line);
            if (!data) {
                return null;
            }
            return { type: args.type, ...data };
        },
        apply: args.apply,
    };
};
export const createTypedStatementHandler = (args, builderType) => {
    return createStatementHandler({
        ...args,
        apply: (stmt, builder) => {
            if (!(builder instanceof builderType)) {
                throw new Error(`Builder must be an instance of ${builderType.name}`);
            }
            args.apply(stmt, builder);
        },
    });
};
//# sourceMappingURL=createTypedStatementHandler.js.map